import { useRef, useState, useEffect } from "react";
import { Box, Text, IconButton } from "@chakra-ui/react";
import { FaExpand, FaCompress } from "react-icons/fa";

export default function GuacamoleAccess() {
  const iframeDynamicHeight = "calc(100vh - 10rem)";
  const fullscreenContainerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  
  const iframeRef = useRef(null);

  const toggleFullScreen = () => {
    const elem = fullscreenContainerRef.current;
    if (!elem) return;

    if (!document.fullscreenElement) {
      elem.requestFullscreen().catch((err) => {
        alert(`Erro ao tentar ativar a tela cheia: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    const onFullScreenChange = () => {
      const isCurrentlyFullscreen = !!document.fullscreenElement;
      setIsFullscreen(isCurrentlyFullscreen);
      if (iframeRef.current) {
        setTimeout(() => {
          iframeRef.current.src = iframeRef.current.src;
        }, 100);
      }
    };
    
    document.addEventListener('fullscreenchange', onFullScreenChange);
    return () => document.removeEventListener('fullscreenchange', onFullScreenChange);
  }, []);

  return (
    <>
      {!isFullscreen && (
        <Box textAlign="center" py={2}>
          <Text color={"#F68633"} fontWeight={"bold"} fontSize="xl">
            ACESSO REMOTO
          </Text>
        </Box>
      )}
      <Box 
        ref={fullscreenContainerRef}
        mx={isFullscreen ? 0 : { base: 1, md: 12, lg: 20 }} 
        mb={isFullscreen ? 0 : "10"}
        boxShadow={isFullscreen ? 'none' : 'md'} 
        borderRadius={isFullscreen ? 0 : "lg"} 
        position="relative"
        bg="white"
      >
        <Box p={isFullscreen ? 0 : { base: 4, md: 6 }}>
          <Box
            borderWidth={isFullscreen ? 0 : "1px"}
            borderRadius={isFullscreen ? 0 : "xl"}
            shadow={isFullscreen ? 'none' : "lg"}
            overflow="hidden"
            h={isFullscreen ? '100vh' : iframeDynamicHeight}
          >
            <iframe
              ref={iframeRef}
              title="Guacamole Login"
              src="https://vps.tagaautopartes.com.br/guacamole/"
              width="100%"
              height="100%"
              frameBorder="0"
            />
          </Box>
        </Box>
        <IconButton
          aria-label={isFullscreen ? "Sair da tela cheia" : "Entrar em tela cheia"}
          icon={isFullscreen ? <FaCompress /> : <FaExpand />}
          onClick={toggleFullScreen}
          position="absolute"
          top={isFullscreen ? "0.5rem" : "2.2rem"}
          right={isFullscreen ? "0.5rem" : "2.2rem"}
          size="sm"
          isRound
          zIndex="docked"
        />
      </Box>
    </>
  );
}